module.exports = __webpack_public_path__ + "static/media/Aragon.5034ec7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Achievements/Aragon.png
// module id = 353
// module chunks = 0